import type { WebMainInfoResponse } from '@module/apis/client-side/main/type';

export const buildUpdatedSidePickList = (
  pickList: WebMainInfoResponse['pick'],
  media: WebMainInfoResponse['pick'][number],
) => {
  const remainingPickList = pickList.filter((pick) => pick.userIdx !== media.userIdx);

  return [media, ...remainingPickList].slice(0, 10);
};
